import styled, { css } from 'styled-components';

import { SharedDatePickerStyles } from '../DatePicker/styled';

export const DatePickerContainer = styled.div<{ $hasError?: boolean; width?: string }>(
  ({ theme: { admanColors, spacers, colors }, $hasError }) => css`
    width: 100%;

    ${SharedDatePickerStyles}

    .react-datepicker__month-container {
      width: 100%;
    }

    .react-datepicker {
      border: none;
      width: 100%;
    }

    .react-datepicker__day-name {
      width: 31px;
    }

    .react-datepicker__day-name::first-letter {
      width: 32px;
    }

    .react-datepicker__day {
      margin: 0;

      &:hover {
        border-radius: 4px;
      }
    }

    .react-datepicker__day--in-selecting-range {
      background-color: ${admanColors!.blue.light.bg1[2]};
      border-radius: 0;
    }

    .react-datepicker__day--in-range {
      background-color: ${admanColors!.blue.light.bg1[2]};
      border-radius: 0;
    }

    .react-datepicker__day--range-start,
    .react-datepicker__day--range-end {
      background-color: ${admanColors!.blue.light.fg[3]};
    }

    .react-datepicker__day--range-start {
      border-radius: 8px 0 0 8px;
    }

    .react-datepicker__day--range-end {
      border-radius: 0 8px 8px 0;
    }

    .react-datepicker__month {
      margin: 0;
      padding: 0 ${spacers?.spacer04};
    }
  `
);
